/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Health_And_Medicine17Inputs */

const en_job_form_enum_health_and_medicine17 = /** @type {(inputs: Job_Form_Enum_Health_And_Medicine17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Health and Medicine`)
};

const de_job_form_enum_health_and_medicine17 = /** @type {(inputs: Job_Form_Enum_Health_And_Medicine17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesundheit und Medizin`)
};

/**
* | output |
* | --- |
* | "Health and Medicine" |
*
* @param {Job_Form_Enum_Health_And_Medicine17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_health_and_medicine17 = /** @type {((inputs?: Job_Form_Enum_Health_And_Medicine17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Health_And_Medicine17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_health_and_medicine17(inputs)
	return en_job_form_enum_health_and_medicine17(inputs)
});
export { job_form_enum_health_and_medicine17 as "job_form_enum_HEALTH_AND_MEDICINE" }